import Transition from "./Transition";
import Logo from "./components/Logo";
import Menu from "./components/Menu";
import Preloader from "./components/Preloader";
import Project from "./pages/Project";
import barba from "@barba/core";
import GSAP from "gsap";
import ProjectSingle from "./pages/ProjectSingle";
import Studio from "./pages/Studio";
import projectCardHover from "./utils/projectCardHover";
import Inspiration from "./pages/Inspiration";
import Home from "./pages/Home";

export default class App {
  init() {
    this.createMobileMenu();
    this.createPreloader();
    this.footerLogoFull();
    this.createProjectPage();
    this.createTransition();
    this.createProjectSinglePage();
    this.createStudioPage();
    this.createUtils();
    this.createInspirationPage();
    this.createHomePage();
  }

  // Page Transition both mobile and desktop
  createTransition() {
    this.transition = new Transition();
  }
  createStudioPage() {
    this.studio = new Studio();
    this.studio.initStackingSticky();
    window.studioInstance = this.studio;
  }
  // Mobile Menu
  createMobileMenu() {
    this.menu = new Menu();
    this.menu.menuToggle();
  }
  footerLogoFull() {
    this.footerLogo = new Logo();
    this.footerLogo.footerLogoReveal();
  }
  createProjectSinglePage(container) {
    this.projectSingle = new ProjectSingle(container);
    this.projectSingle.mobileDropDown();
    this.projectSingle.lightHouseToggle();
    this.projectSingle.bindKeyboardControls();
    this.projectSingle.handleProjectNameHeader();
    // Store globally so Transition can access it
    window.projectSingleInstance = this.projectSingle;

    return this.projectSingle;
  }
  createInspirationPage() {
    this.inspirationPage = new Inspiration();
    this.inspirationPage.ajaxFilter();
  }
  createUtils() {
    projectCardHover();
  }
  createProjectPage() {
    this.project = new Project();
    this.project.pageVariantMobile();
  }
  // Preloader
  createPreloader() {
    new Preloader();
  }
  createHomePage() {
    this.home = new Home();
    this.home.projectTypeSection();
  }
}

new App().init();
